module.exports = __webpack_public_path__ + "static/media/amazonia-thumbnail.6623abc2.webp";